//sameSite: 'Strict' | 'none' | 'Lax' 
export default {

  set: (name, value, expires, sameSite = null, path = "/") => {
    document.cookie = `${name}=${value}; ${expires ? "expires="+expires.toUTCString() : ""}; path=${path}; SameSite=${sameSite}; ${window.location.protocol === 'https:' ? 'Secure;' : ''}`;
  },

  delete: (name, path = "/") => {
      let expireDate = new Date();
      expireDate.setFullYear(2000);
      document.cookie = `${name}=DELETED; expires=${expireDate.toString()}; path=${path}`;
  },

  get: (name) => {
      let cookies = {
          string: '',
          split: [],
          object: {}
      }

      cookies.string = document.cookie;
      cookies.split = cookies.string.split('; ');
      cookies.split.map(item => {
          let splitted = item.split('=');
          cookies.object[splitted[0]] = splitted[1];
      })
      
      return cookies.object[name] || undefined;
  }

}
